/* 계좌이체 구매 버튼 — 장바구니에 담고 결제 화면으로 바로 보낸다.
 *
 * ─── 왜 별도 버튼인가 ──────────────────────────────────────────────────────
 *
 * 결제수단이 PayPal·카드 / Khan Bank 계좌이체 두 가지다. "지금 구매"(Shopify
 * 동적 결제 버튼)는 가속 결제 쪽으로만 간다. 투그릭으로 이체하려는 고객이
 * 장바구니 → 결제로 두 단계를 더 밟아야 할 이유가 없어서 한 번에 보낸다.
 *
 * ─── Khan Bank 를 미리 선택해 둘 수 있는가 ─────────────────────────────────
 *
 * 없다. 결제 화면의 결제수단 선택은 Shopify 가 그리고, 스토어프런트에서
 * URL 이나 폼으로 지정할 방법이 없다 (체크아웃 UI 확장은 앱 영역). 현재는
 * 관리자의 결제수단 순서상 Khan Bank 가 기본 선택으로 뜬다 — 그 설정이
 * 바뀌면 이 버튼도 선택 상태를 보장하지 못한다.
 *
 * ─── 실패하면 ──────────────────────────────────────────────────────────────
 *
 * 담기에 실패하면(품절, 수량 제한) 이동하지 않고 버튼을 되돌린다. 결제 화면에
 * 빈 장바구니로 보내는 것보다 제자리에 두는 편이 낫다 — 바로 아래 "카트에
 * 추가" 버튼이 같은 오류를 테마 기본 UI 로 보여준다.
 */
(function () {
  function busy(btn, on) {
    btn.classList.toggle('tg-buy-now--busy', on);
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /**
   * 어느 버튼으로 들어왔는지 장바구니 속성에 남긴다. 주문서에
   * "희망 결제수단: Khan Bank 계좌이체" 로 보인다.
   *
   * ─── 왜 두 버튼 모두 기록하는가 ──────────────────────────────────────────
   *
   * 계좌이체만 기록하면, 고객이 계좌이체를 눌렀다가 돌아와 PayPal 을 누른 경우
   * 먼저 쓴 값이 장바구니에 그대로 남는다. 매번 덮어써야 실제로 누른 쪽이 남는다.
   *
   * ─── 실패하면 그냥 넘어간다 ──────────────────────────────────────────────
   *
   * 이 값은 운영 참고용이다. 기록에 실패했다고 결제를 막을 이유가 없으므로
   * 어떤 오류든 삼키고 체크아웃으로 보낸다.
   *
   * 고객이 결제 화면에서 다른 수단을 고르면 이 값과 실제 결제수단은 달라진다 —
   * "눌러서 들어온 경로" 이지 "확정된 결제수단" 이 아니다.
   */
  function markPreferredMethod(btn) {
    var url = btn.getAttribute('data-update-url');
    var key = btn.getAttribute('data-pay-attr-key');
    var value = btn.getAttribute('data-pay-attr');
    if (!url || !key || !value) return Promise.resolve();

    var attributes = {};
    attributes[key] = value;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-khan-buy]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var form = document.getElementById(btn.getAttribute('data-form-id'));
    if (!form) return;

    var addUrl = btn.getAttribute('data-add-url');
    var checkoutUrl = btn.getAttribute('data-checkout-url');
    if (!addUrl || !checkoutUrl) return;

    busy(btn, true);

    /**
     * FormData 는 form 속성으로 연결된 바깥 입력도 함께 담는다 — Dawn 의 수량
     * 입력이 폼 밖에 있어도 수량이 그대로 넘어간다.
     */
    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data && data.status) throw new Error(data.description || 'cart/add rejected');
        return markPreferredMethod(btn);
      })
      .then(function () {
        window.location.assign(checkoutUrl);
      })
      .catch(function () {
        busy(btn, false);
      });
  });
})();
